import { useCallback, useEffect, useState, useRef } from 'react';
import { pagination } from '../constants';

const EMPTY_FILTERS = {};

const useFetchListing = ({ migrationId, get, filters = EMPTY_FILTERS }) => {
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState({ data: [], total: 0 });
  const [requestError, setListRequestError] = useState(false);
  const [page, setPage] = useState(1);
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  const debounceTimer = useRef(null);

  const onNavigate = useCallback((currentPage) => setPage(currentPage), []);

  useEffect(() => {
    if (debounceTimer.current) clearTimeout(debounceTimer.current);

    debounceTimer.current = setTimeout(() => {
      setDebouncedFilters(filters);
      setPage(1);
    }, 500);

    return () => {
      if (debounceTimer.current) clearTimeout(debounceTimer.current);
    }
  }, [filters]);

  useEffect(() => {
    setLoading(true);
    setListRequestError(false);

    get({
      page,
      per_page: pagination.limit,
      migrationId,
      ...debouncedFilters
    })
      .then(({ data }) => setList(data))
      .catch(() => setListRequestError(true))
      .finally(() => setLoading(false))
  }, [page, debouncedFilters, migrationId, get]);

  return {
    loading,
    list,
    requestError,
    page,

    onNavigate,
  }
}

export default useFetchListing;
